import { useState, useContext } from 'react';
import { TFunction } from 'i18next';
import { useTranslation } from 'react-i18next';
import { getSiteQueryOptions } from '@/api/queries/sites';
import { ErrorComponent } from '@/components/generalError';
import { Overview } from '@/components/siteDetails/overview/overview';
import { BackButton } from '@/components/ui/backButton';
import { Tabs } from '@/components/ui/tabs';
import { useSuspenseQuery } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router';
import { Members } from '@/components/siteDetails/members/members';
import { routes } from '@/types/routes';
import { QueryStateKey, SitesContext } from '@/context/sitesContext';

export const Route = createFileRoute('/_app/sites/$siteId/')({
  loader: ({ context: { queryClient }, params: { siteId } }) => {
    return queryClient.ensureQueryData(getSiteQueryOptions(siteId));
  },
  errorComponent: ErrorComponent,
  component: RouteComponent,
});

const TABS = (t: TFunction) => {
  return [
    {
      index: 0,
      name: t('tabs.overview', { ns: 'sites' }),
      component: <Overview />,
    },
    {
      index: 1,
      name: t('tabs.members', { ns: 'sites' }),
      component: <Members />,
    },
  ];
};

function RouteComponent() {
  const { t } = useTranslation();
  const params = Route.useParams();
  const { siteId } = params as { siteId: string };
  const [ activeTab, setActiveTab ] = useState(0);
  const { data: site } = useSuspenseQuery(getSiteQueryOptions(siteId));
  const { page: sitesListPage } = useContext(SitesContext);

  return (
    <section className="flex flex-col flex-1">
      <header className="flex flex-col space-y-space-2xs">
        <BackButton
          linkLabel={ t('routes.sitesList') }
          href={ `${routes.sites}?${QueryStateKey}=${sitesListPage}` }
        />
        <div className="flex items-center gap-space-lg">
          <h1 className="font-h1">
            { site.name }
          </h1>
        </div>
      </header>

      <Tabs
        tabs={ TABS(t) }
        activeTab={ activeTab }
        setActiveTab={ setActiveTab }
        className="mt-space-2xl"
      />
    </section>
  );
}
